import { instance as YouTubeIframeLoader } from './youtube-iframe-api';
import Mustache from 'mustache';
import a11yModal from '../../../../common/build/helpers/a11y-modal';

/**
 * Open video modal if link points to youtube video
 */

const videoModal = {

  videoPlayers: [] as any[],
  YT: null as any,

  /**
   * Init Youtube API for modal's iframe and save reference to the player
   * @param modal
   */
  initYTApi(modal) {
    const self = this;
    const videoIframes = modal.querySelector('iframe');

    if (!self.YT) {
      YouTubeIframeLoader.load((YT) => {
        self.YT = YT;
        self.videoPlayers.push(new YT.Player(videoIframes.id));
      });
    } else if (self.YT && self.YT.Player) {
      self.videoPlayers.push(new self.YT.Player(videoIframes.id));
    }
  },

  /**
   * Create Youtube a11y modal and insert it to the DOM
   * @param linkData
   */
  createYoutubeModal: function (linkData) {
    const modalTemplate = `<div id="{{id}}" class="modal{{#css}} {{css}}{{/css}}" data-youtube-modal="" aria-hidden="true">
      <div class="modal__backdrop" data-a11y-dialog-hide></div>
      <div class="modal__dialog" role="dialog" aria-labelledby="{{id}}-title">
        <div class="modal__content" role="document">
          <div class="modal__header">
            <h4 class="modal__title" id="{{id}}-title">{{title}}</h4>
            <button type="button" class="modal__close" data-a11y-dialog-hide aria-label="<%@ 'ui_close' %>"><span aria-hidden="true">×</span></button>
          </div>

          <div class="modal__body">
            <div class="video video--embed">
            <iframe id="yt-modal-{{id}}" data-src="https://www.youtube-nocookie.com/embed/{{id}}?controls=1&rel=0&wmode=transparent&enablejsapi=1" frameborder="0" allowfullscreen></iframe>
          </div>
          </div>
        </div>
      </div>
    </div>`;

    const el = document.createElement('div');
    el.innerHTML = Mustache.render(modalTemplate, linkData);
    document.body.insertAdjacentElement('afterbegin', el);
  },

  /**
   * Parse video URL and return video ID and type
   *
   * @param {string} url
   * @returns {object}
   */
  parseVideo: function (url) {

    // - Supported YouTube URL formats:
    //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
    //   - http://youtu.be/My2FRPA3Gf8
    //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
    // - Supported Vimeo URL formats:
    //   - http://vimeo.com/25451551
    //   - http://player.vimeo.com/video/25451551

    if (!url) {
      return null;
    }

    let type;

    const match = url.match(/(http:|https:|)\/\/(player\.|www\.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/);
    if (match && match[3].includes('youtu') > -1) {
      type = 'youtube';
    } else if (match && match[3].includes('vimeo') > -1) {
      type = 'vimeo';
    }

    return {
      type: type,
      id: RegExp.$6
    };

  },

  /**
   * Creates modals for youtube links and attaches YT player and modal functionality

   * @returns {boolean}
   */
  addYouTubeModalLinks: function (ytVideoLinks) {
    const self = this;

    // create modals
    ytVideoLinks.forEach(function (el) {
      self.createYoutubeModal(el.data);

      el.link.setAttribute('data-modal-link', el.data.id);
    });

    // Init a11y Modal functionality
    const modals = document.querySelectorAll('[data-youtube-modal]');
    modals.forEach((modal) => {
      a11yModal.createModal(modal as HTMLElement);
    });

    // Connect modal hide event with stopVideo
    document.addEventListener('modal.hide', function (e) {
      self.videoPlayers.forEach((player) => {
        if (typeof player.stopVideo === 'function') {
          player.stopVideo();
        }
      });
    })

    // Lazy init youtube api when modal is shown
    document.addEventListener('modal.show', function (e) {
      const modalId = (e.target as HTMLElement)?.id || '';
      const modal = document.getElementById(modalId);
      const modalIframe = modal?.querySelector(`#yt-modal-${modalId}`);

      if (modalIframe && !modalIframe.getAttribute('src')) {
        modalIframe.setAttribute('src', modalIframe.getAttribute('data-src') || '');

        // init YT api for modal
        self.initYTApi(modal);
      }
    });

    return false;
  },

  /**
   * Init modals for video links with specific format
   *
   */
  init: function () {
    console.log('videoModal.init()');

    const self = this;


    const contentLinks = document.querySelectorAll('main a');
    let ytVideoLinks: { link: Element, data: { type: string, id: string } }[] = [];
    let vimeoVideoLinks: { link: Element, data: { type: string, id: string } }[] = []; // Not implemented

    contentLinks.forEach(function (link) {
      const data = self.parseVideo(link.getAttribute('href'));
      if (data && data.type === 'youtube') {
        ytVideoLinks.push({ link, data });
      } else if (data && data.type === 'vimeo') {
        vimeoVideoLinks.push({ link, data });
      }
    });

    /** Youtube */
    this.addYouTubeModalLinks(ytVideoLinks);

    /** Vimeo TBD */
  }
}

export default videoModal;
